import React from "react";
import {
  BadgeColor,
  Button,
  Grid,
  Icons,
  Loader,
  StatusChip,
  Text,
  Toast,
} from "@pushpress/shared-components";
import { useFeatureFlag } from "../../../context/features";
import { RECURRING_APPT_FEATURE_FLAG } from "../../../context/features/features.utils";
import { useToggle } from "../../../hooks/state";
import CreditsModal from "../CreditsModal";

interface SessionsCreditProps {
  appointmentTypeUuid?: string;
  userUuid?: string;
  credits?: number;
  loading: boolean;
  onSuccess: VoidFunction;
}

function SessionsCredit(props: SessionsCreditProps) {
  const { appointmentTypeUuid, userUuid, credits, loading, onSuccess } = props;

  const { isFeatureEnabled } = useFeatureFlag();

  const recurringBookingFlag = isFeatureEnabled(RECURRING_APPT_FEATURE_FLAG);

  const [modalVisible, modalActions] = useToggle(false);

  const handleAddCreditsSuccess = () => {
    modalActions.off();
    onSuccess();
  };

  if (loading) {
    return (
      <Grid container justifyContent="center" className="mt-2">
        <Loader />
      </Grid>
    );
  }

  const addCreditsDisabled = credits === undefined;

  return (
    <>
      <Grid container alignItems="center" className="pt-2" spacing={0}>
        <Grid item xs={9} container alignItems="center" spacing={0}>
          <Grid item>
            <Text
              component="span"
              variant="body-lg"
              color="wolf-600"
              className="mr-2"
            >
              Credits
            </Text>
          </Grid>
          <Grid item>
            <StatusChip
              label={credits !== undefined ? String(credits) : "--"}
              color={BadgeColor.Gray}
              size="small"
            />
          </Grid>
        </Grid>
        <Grid item xs={3} container justifyContent="flex-end">
          <Button
            text="Credits"
            buttonType="secondary"
            type="button"
            icon={Icons.Plus}
            iconLocation="left"
            disabled={addCreditsDisabled}
            onClick={modalActions.on}
          />
        </Grid>
      </Grid>
      {credits === 0 && !recurringBookingFlag && (
        <div className="mt-4">
          <Toast
            icon={Icons.Warning}
            iconColor="warning"
            title="No credits"
            message="Add credits to create bookings. "
          />
        </div>
      )}
      <CreditsModal
        visible={modalVisible}
        userUuid={userUuid}
        appointmentTypeUuid={appointmentTypeUuid}
        onClose={modalActions.off}
        onSuccess={handleAddCreditsSuccess}
      />
    </>
  );
}

export default SessionsCredit;
